<template>
	<div :class="`btn-wrapper ${link.direction}`">
		<router-link :to="link.url" :class="`btn ${link.color}`">{{ link.label }}</router-link>
	</div>
</template>

<script>
//data
import Link from "../data-schema/Link.js";

export default {
	name: "LinkButton",
	props: {
		link: {
			type: Link,
			required: true
		}
	}
};
</script>
